import { faScreenUsers } from '@fortawesome/pro-light-svg-icons/faScreenUsers'

import Icon from '@space-core/components/icon'
import Image from '@space-core/components/image'

import { ContainerImage } from './styles'

export type CoverProps = {
  pictureUrl?: string
}

const Cover = ({ pictureUrl }: CoverProps) => {
  return (
    <ContainerImage className='_rounded-lg _mr-md-4 _bg-gray-200 _overflow-hidden'>
      {pictureUrl ? (
        <Image src={pictureUrl} alt='cover' className='_w-full _rounded-lg' />
      ) : (
        <div className='_d-flex _h-full _align-items-center _justify-content-center'>
          <Icon aria-hidden className='_text-5 _text-gray-500' icon={faScreenUsers} />
        </div>
      )}
    </ContainerImage>
  )
}

export default Cover
